"use client";
import { jsx as o } from "react/jsx-runtime";
import { s, B as y } from "../../ButtonLinkBase-X3fB-SiJ.js";
import j from "classnames";
const v = ({
  active: f,
  children: l,
  className: r,
  destructive: i = !1,
  disabled: d,
  trailingIcon: t,
  leadingIcon: e,
  representation: b = "button",
  id: p,
  isFullwidth: n = !1,
  isFullwidthMobile: B = !1,
  loading: a = !1,
  onClick: c,
  size: N = "medium",
  type: h,
  variant: m = "primary",
  ref: k,
  title: u,
  ...w
}) => {
  const x = j(
    s[m === "inline" ? "link" : b],
    s[N],
    s[m],
    {
      [s.destructive]: i,
      [s.loading]: a,
      [s.fullwidth]: n,
      [s["fullwidth-mobile"]]: B
    },
    r
  );
  return /* @__PURE__ */ o(
    "button",
    {
      "data-testid": "button",
      className: x,
      "aria-selected": f,
      disabled: d || a,
      ref: k,
      id: p,
      type: h,
      onClick: c,
      ...w,
      title: !u && !l && (e || t) ? e || t : u,
      children: /* @__PURE__ */ o(y, { leadingIcon: e, trailingIcon: t, loading: a, children: l })
    }
  );
};
export {
  v as default
};
